import React, { useState, useEffect, useContext } from 'react';
import { connect } from 'react-redux';
import { ObjModal } from '../../../../contexts';
import { Timeline, TimelineEvent } from 'react-event-timeline';
import EmailIcon from '@mui/icons-material/Email';
import TextsmsIcon from '@mui/icons-material/Textsms';
import CallIcon from '@mui/icons-material/Call';
import TimelineEmail from '../Timeline/Email';
import TimelineSms from '../Timeline/Txt';


const Comms = ( { aid, layout, commsLoaded } ) => {
    const { obj } = useContext( ObjModal );
    
    const formatDate = ( d ) => {
        const dd = new Date( d );
        return dd.toLocaleString();
    };

    const getCommIcon = ( t ) => {
        let icon;

        switch ( t ) {
            case 'call':
                icon = <CallIcon />;
                break;

            case 'sms':
                icon = <TextsmsIcon />;
                break;

            case 'email':
                icon = <EmailIcon />;
                break;

            default:
                console.log( 'unknown comm icon type: ' + t );
        }

        return icon;
    };

    return (
        <Timeline lineColor='var( --tf-blue )'>
            {
                obj?.comms?.map( c => (
                    <TimelineEvent
                        key={c.cid}
                        title={c.name ?? ''}
                        createdAt={ formatDate( c.commDate ? c.commDate : c.createdDate ) }
                        icon={ getCommIcon( c.commType ) }
                        iconStyle={ { color: 'var( --tf-orange )' } }
                        bubbleStyle={ { borderColor: 'var( --tf-orange )' } }
                    >
                        {
                            ( c.commType === 'email' ) ? (
                                <TimelineEmail cid={c.cid} />
                            ) : (
                                ( c.commType === 'sms' ) ? (
                                    <TimelineSms cid={c.cid} />
                                ) : (
                                    ( c.video ) ? (
                                        <video src={`https://tf-media.s3.amazonaws.com/${aid}/${c.mediaUrl}`} controls playsInline style={ { width: '400px' } }></video>
                                    ) : (
                                        ( c.audio ) ? (
                                            <audio src={`https://tf-media.s3.amazonaws.com/${aid}/${c.mediaUrl}`} controls playsInline></audio>
                                        ) : (
                                            ( c.details ) ? (
                                                <span>{c.details}</span>
                                            ) : (
                                                null
                                            )
                                        )
                                    )
                                )
                            )
                        }
                    </TimelineEvent>
                ) )
            }
        </Timeline>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid
} );
  
const mapDispatch = ( dispatch ) => ( {
    // load: dispatch.lists.loadGroups,
} );
  
export default connect( mapProps, mapDispatch )( Comms );